














import { defineClassComponent } from '@/hooks'

export default defineClassComponent<{
  count: number
  showStart: boolean
  price: string | number
}>(
  {
    props: ['count', 'showStart', 'price'],
  },
  () => class {},
)
